module.exports = __webpack_public_path__ + "static/media/homeimg.a6f89b2c.png";